import React, { useEffect, useState } from 'react';
import '../profile.css';
import './seller-support.css';
import api from '../../seller-apis/api';
import './seller-support-list.css'
import Pagination from '../common/PaginationComponent';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { Tooltip, Modal, Badge } from 'react-bootstrap';
import ChatModal from './ChatModal';

const STATUS_LIST = [
    {
        key: 'ALL',
        label: 'All'
    },
    {
        key: 'OPEN',
        label: 'Open'
    },
    {
        key: 'RESOLVED',
        label: 'Resolved'
    },
    {
        key: 'ONGOING',
        label: 'Ongoing'
    },
]
const HEADERS = [
    {
        key: 'ticketId',
        label: 'Ticket ID'
    },
    {
        key:'orderId',
        label:'Order ID'
    },
    {
        key: 'type',
        label: 'Type'
    },
    {
        key: 'desc',
        label: 'Description'
    },
    {
        key: 'remark',
        label: 'Remark'
    },
    {
        key: 'status',
        label: 'Status'
    },
]


function HideText(props) {
    const {
        text
    } = props;

    const determinePlacement = () => {
        const screenHeight = window.innerHeight;
        const element = document.getElementById('tablePopup');
        if (element) {
            const elementRect = element.getBoundingClientRect();
            return elementRect.top > screenHeight / 2 ? 'top' : 'bottom';
        }
        return 'bottom';
    };
    const popover = (
        <Popover id="tablePopup">
            <Popover.Body className='seller-support-list-table__popup'>
                {text}
            </Popover.Body>
        </Popover>
    );
    if (text.length > 15) {
        return (
            <OverlayTrigger trigger={['hover', 'focus']} overlay={popover} placement={determinePlacement()}>
                <span style={{ fontSize: 'inherit', fontFamily: 'inherit' }}>
                    {text.substring(0, 15) + "..."}
                </span>
            </OverlayTrigger>
        )

    } else {
        return <>{text}
        </>;
    }

}

function ShowRemarks(props) {
    const {
        remarks,
        fetchReq
    } = props;
    const [remarkData, setRemarkData] = useState("")
    const [showModal, setShowModal] = useState(false)

    const handleOpenModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

        // Remove useEffect that calls fetchReq on every instance
        // Instead, parent should handle data refresh after modal closes

    const determinePlacement = () => {
        const screenHeight = window.innerHeight;
        const element = document.getElementById('tablePopup');
        if (element) {
            const elementRect = element.getBoundingClientRect();
            return elementRect.top > screenHeight / 2 ? 'top' : 'bottom';
        }
        return 'bottom';
    };

    const popover = (
        <Popover id="tablePopup">
            <Popover.Body className='seller-support-list-table__popup'>
                {remarks?.remarks?.[0]?.msg}
            </Popover.Body>
        </Popover>
    );

    return (
        <div>
            <div className="cursor-pointer" onClick={() => {
                handleOpenModal();
                setRemarkData(remarks);
            }}>
                {(remarks?.remarks?.[0]?.new_msg === true && remarks?.remarks?.[0]?.from === "admin") && (
                    <Badge pill bg="danger">New</Badge>
                )
                }
                <a href="#" className="but">{!remarks?.remarks?.[0] ? "Send Message" : ""}</a>
                {remarks?.remarks?.[0]?.msg.length > 15 ?
                    <OverlayTrigger trigger={['hover', 'focus']} overlay={popover} placement={determinePlacement()}>
                        <span style={{ fontSize: 'inherit', fontFamily: 'inherit' }}>
                            {remarks?.remarks?.[0]?.msg.substring(0, 15) + "..."}
                        </span>
                    </OverlayTrigger> :
                    <a href="#" className="but">{remarks?.remarks?.[0]?.msg && remarks?.remarks?.[0]?.msg}</a>}

            </div>
            <ChatModal
                show={showModal}
                handleClose={handleCloseModal}
                ticket={remarkData}
                flag="SellerSupportMsg"
            />
        </div>

    )
    // const [modal, setModal] = useState(false);
    // if (remarks && remarks.length) {

    //     const len = remarks.length;
    //     const remark = remarks[len - 1];
    //     const hideText = (text, remarksLen) => {

    //         if ((text && (text.length > 15)) || remarksLen > 1) {
    //             return (<OverlayTrigger
    //                 placement="top"
    //                 overlay={
    //                     <Tooltip>
    //                         Click here to see more
    //                     </Tooltip>
    //                 }
    //             >
    //                 <span style={{ fontFamily: 'inherit', fontSize: 'inherit' }}>
    //                     {text && (text.length > 15) ? text.substring(0, 15) + "..." : text}
    //                 </span>

    //             </OverlayTrigger>)
    //         }
    //         return (<span style={{ fontFamily: 'inherit', fontSize: 'inherit' }}>
    //             {text}
    //         </span>);



    //     }

    //     const showUser = (user) => {
    //         if (user && user?.firstname && user?.lastname) {
    //             return (<div className='seller-support-list-table__user text-end me-3'>
    //                 ({`${user?.firstname} ${user?.lastname}`})
    //             </div>)
    //         }
    //         return null
    //     }
    //     const dateConversion = (date) => {
    //         return new Date(date).toLocaleString()
    //     }
    //     const showDate = (date) => {
    //         if (date) {
    //             return (<div className='seller-support-list-table__date text-end pr-3'>
    //                 {dateConversion(date)}
    //             </div>)
    //         }
    //         return null
    //     }
    //     return (
    //         <>
    //             <Modal
    //                 size="xl"
    //                 centered
    //                 show={modal}
    //                 scrollable
    //                 onHide={() => setModal(false)}>
    //                 <Modal.Header closeButton>
    //                     <p className='m-auto p-3'>
    //                         Remarks
    //                     </p>
    //                 </Modal.Header>
    //                 <Modal.Body className=' p-0'>

    //                     <table className='seller-support-remark-table'>
    //                         <thead className='seller-support-remark-table__head'>
    //                             <tr className='seller-support-remark-table__row'>
    //                                 <th className='seller-support-remark-table__cell' style={{ width: "25%" }}>Updated Date</th>
    //                                 <th className='seller-support-remark-table__cell'>Remark</th>
    //                                 <th className='seller-support-remark-table__cell' style={{ width: "25%" }}>Updated By</th>
    //                             </tr>
    //                         </thead>
    //                         <tbody className='seller-support-remark-table__body'>
    //                             {
    //                                 remarks.map((value, index) =>
    //                                     <tr key={'remarks' + index} className='seller-support-remark-table__row'>
    //                                         <td className='seller-support-remark-table__cell'>
    //                                             {new Date(value.remark_date).toLocaleString()}
    //                                         </td>
    //                                         <td className='seller-support-remark-table__cell'>
    //                                             {value.msg}
    //                                         </td>
    //                                         <td className='seller-support-remark-table__cell'>
    //                                             {value?.user ? `${value?.user?.firstname} ${value?.user?.lastname}` : null}
    //                                         </td>
    //                                     </tr>
    //                                 )
    //                             }

    //                         </tbody>
    //                     </table>

    //                 </Modal.Body>
    //             </Modal >

    //             <div style={{ cursor: 'pointer' }} onClick={() => setModal(true)}>
    //                 {hideText(remark.remark, len)}
    //             </div>
    //             {showUser(remark.user)}
    //             {showDate(remark.remark_date)}
    //         </>

    //     )
    // } else {
    //     return 'N/A'
    // }
}
function SellerSupportList() {

    const [rows, setRows] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [filters, setFilters] = useState({type:"issues"});
    const [page, setPage] = useState(1)
    //states
    const [visibility, setVisibility] = useState({});
    // image modal state
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [mediaType, setMediaType] = useState("");
    const [mediaUrl, setMediaUrl] = useState("");
    //Re-open modal
    const [isReOpenModal, setIsReOpenModal] = useState(false);
    const [selectedRating, setSelectedRating] = useState(0);
    const [reOpenDescription, setReOpenDescription] = useState("");
    const [reOpenId, setReOpenId] = useState()
    const [ratingError, setRatingError] = useState("");
    const [descriptionError, setDescriptionError] = useState("");


    useEffect(() => {
        fetchReq()
    }, [filters]);

    // useEffect for id and fetch data, skip first render
    const isFirstRender = React.useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (isReOpenModal === false) {
            setReOpenId();
            fetchReq();
        }
    }, [isReOpenModal]);

    const fetchReq = async () => {
        const res = await api.Support.sellerReq({
            offset: 0,
            limit: 10,
            ...filters
        })
        setRows(res?.data?.data?.records)
        setTotalRecords(res?.data?.data?.totalRecords)
    }

    const dateConversion = (date) => {
        return new Date(date).toLocaleString()
    }

    const showFilter = (value) => {
        if (value.key === 'status') {
            return (<>
                <div>
                    {value.label}
                </div>
                <div className='pr-2'>
                    <select
                        name="status"
                        className='seller-support-list-table__input ms-2 mb-2'
                        onChange={handleFilters}>
                        {
                            STATUS_LIST.map((status) =>
                                <option key={status.key} value={status.key}>
                                    {status.label}
                                </option>
                            )
                        }
                    </select>
                </div>
            </>)
        }
        else if(value.key === 'orderId'){
            return (
                <>
                <div>{value.label}</div>
                <div className='pr-2'>
                    <input type="text"
                    //  value={orderId}
                       placeholder='Search'
                        className='seller-support-filter-input px-2'
                        onKeyDown={handleOrderFilter}
                    //  onChange={(e) => setOrderId(e.target.value)}
                    //   onKeyUp={(e) => checkevent(e, "id")} 
                      />
                   
                </div>
                </>
            )
        }
        return value.label
    }

    const handleFilters = (e) => {
        const {
            value
        } = e.target;
        if (value === 'ALL') {
            const _filters = { ...filters };
            delete _filters['status'];
            setFilters({
                ..._filters,
                offset: 0
            })
        } else {
            setFilters((prev) => ({
                ...prev,
                status: value,
                offset: 0
            }))
        }
        setPage(1)
    }

    const handleOrderFilter = (e) => {
        if (e.key !== 'Enter') return;
        const {
            value
        } = e.target;
        if (value) {
            setFilters((prev) => ({
                ...prev,
                orderId: value,
                offset: 0
            }))
        } else {
            const _filters = { ...filters };
            delete _filters['orderId'];
            setFilters({
                ..._filters,
                offset: 0
            })
        }
        setPage(1)
    }

    const handlePagination = (page) => {
        setFilters((prev) => ({
            ...prev,
            offset: (page - 1) * 10
        }))
        setPage(page)
    }

    const showDate = (date) => {
        if (date) {
            return (<div className='seller-support-list-table__date text-center pr-3'>
                {dateConversion(date)}
            </div>)
        }
        return null
    }

    const toggleVisibility = (id) => {
        setVisibility((prevState) => ({
            ...prevState,
            [id]: prevState[id] === "show Attachments" ? "Hide Attachments" : "show Attachments"
        }));
    };
    console.log("reOpenId", reOpenId);


    const handleReOpenSubmit = async (e) => {
        e.preventDefault();

        let isValid = true;

        // Reset errors
        // setRatingError("");
        setDescriptionError("");

        // Validate rating
        // if (selectedRating === 0) {
        //     setRatingError("Please select a rating.");
        //     isValid = false;
        // }

        if (reOpenDescription.trim() === "") {
            setDescriptionError("Please add a reason.");
            isValid = false;
        }

        if (!isValid) return;

        const body = { status: 'REOPEN' };
        const _id = reOpenId?._id;

        try {
            let data = {
                sellerSupportReqId: reOpenId?._id,
                vendorName: reOpenId?.vendor_name,
                from: "vendor",
                msg: reOpenDescription,
                new_msg: true
            }
            await api.supportTicket
                .saveSellerSupportMessage(data)
                .then((messages) => {
                    api.Support.updateSeller(_id, body)
                        .then((res) => {
                            console.log("res", res);
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                    console.log(messages);
                    setIsReOpenModal(false);
                    setSelectedRating(0);
                    setReOpenDescription("");
                })
        } catch (err) {
            console.log("err", err);
        }
    };

    return (
        <>
            <div className='seller-support-list'>

                <table className="new-table-design w-100">
                    <thead className='seller-support-list-header'>
                        <tr className=''>
                            {
                                HEADERS.map((value, key) =>
                                    <th className='seller-header pt-4' key={value.key}>
                                        {showFilter(value)}
                                    </th>
                                )
                            }
                        </tr>
                    </thead>
                    <tbody className=''>
                        {rows.map((row) =>
                            <tr className='' key={row._id}>
                                {console.log("row", row)
                                }
                                <td className=''>
                                    {row.ticket_no}
                                    {
                                        showDate(row.created_at)
                                    }
                                </td>
                                <td className=''>
                                    {row?.orderId || "N/A"}
                                </td>
                                <td className=''>
                                    {row.req_type}
                                </td>
                                <td className=''>

                                    <HideText text={row?.desc || ""} />
                                    {(row?.media && row?.media?.length > 0) ?
                                        visibility[row._id] === "show Attachments" ? (
                                            <>
                                                <p
                                                    className="seller-support-list-table__date cursor-pointer"
                                                    onClick={() => toggleVisibility(row._id)}
                                                >
                                                    Hide Attachments
                                                </p>
                                            </>
                                        ) : (
                                            <>
                                                <p
                                                    className="seller-support-list-table__date cursor-pointer"
                                                    onClick={() => toggleVisibility(row._id)}
                                                >
                                                    show Attachments
                                                </p>
                                            </>
                                        ) : ""}
                                    {visibility[row._id] === "show Attachments" && (
                                        <div className="attachments-container">
                                            <div className="attachments-grid">
                                                {row?.media?.map((item) => {
                                                    return (
                                                        <>
                                                            {(item?.mediaType === "image" && item?.url) &&
                                                                <div className="attachment-preview" onClick={() => {
                                                                    setMediaUrl(item.url);
                                                                    setMediaType("image");
                                                                    setIsModalOpen(true);
                                                                }}>
                                                                    <img
                                                                        src={item?.url}
                                                                        alt="image"
                                                                        className="attachment-image"
                                                                    />
                                                                </div>
                                                            }
                                                            {(item?.mediaType === "video" && item?.url) &&
                                                                <div className="attachment-preview" onClick={() => {
                                                                    setMediaUrl(item.url);
                                                                    setMediaType("video");
                                                                    setIsModalOpen(true);
                                                                }}>
                                                                    <video
                                                                        src={item?.url}
                                                                        alt="video"
                                                                        // autoPlay
                                                                        className="attachment-image"
                                                                    />
                                                                </div>
                                                            }
                                                        </>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    )
                                    }
                                </td>
                                <td className=''>

                                    <ShowRemarks remarks={row} fetchReq={fetchReq} />
                                    {/* <td className="cursor-pointer" onClick={() => {
                                    handleOpenModal();
                                    setTicket(ticket);
                                }}>
                                     <a href="#" className="but">{!row?.vendorMsgInfo?.latestMessage ? "Send Message" : ""}</a>
                                    <a href="#" className="but">{ticket?.vendorMsgInfo?.latestMessage}</a> 
                                    xyz
                                </td> */}

                                </td>
                                <td className=''>
                                    <span className={row.status === 'OPEN' ? '--open' : '--resolved'}>
                                        {row.status}
                                    </span>
                                    {
                                        showDate(row.resolved_at)
                                    }
                                    {row.status === "RESOLVED" &&
                                        <button className="status-button mb-2" onClick={() => {
                                            setIsReOpenModal(true); setReOpenId(row);
                                        }}>RE-OPEN</button>
                                    }

                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <Pagination
                currentPage={page}
                totalRecords={totalRecords}
                itemsPerRow={10}
                handlePageChange={handlePagination} />
            {isModalOpen && (
                <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        {mediaType === "image" ? (
                            <img src={mediaUrl} alt="Modal Content" className="modal-image" />
                        ) : (
                            <video src={mediaUrl} controls className="modal-video" />
                        )}
                        <button className="close-modal" onClick={() => setIsModalOpen(false)}>
                            ×
                        </button>
                    </div>
                </div>
            )}
            {isReOpenModal && (
                <div className="modal-overlay" onClick={() => {
                    setIsReOpenModal(false); setReOpenId(); setSelectedRating(0);
                    setReOpenDescription(""); setRatingError("");
                    setDescriptionError("");
                }}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-xmodal" onClick={() => {
                            setIsReOpenModal(false); setReOpenId(); setSelectedRating(0);
                            setReOpenDescription(""); setRatingError("");
                            setDescriptionError("");
                        }}>
                            ×
                        </button>
                        <form onSubmit={handleReOpenSubmit}>
                            {/* <div className="rating-section">
                        <label className='label'>Rate your experince:</label>
                        <div className="stars">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <span
                                    key={star}
                                    className={`star ${star <= selectedRating ? "selected" : ""}`}
                                    onClick={() => { setSelectedRating(star); if (ratingError) setRatingError(""); }}
                                >
                                    ★
                                </span>
                            ))}
                        </div>
                        {ratingError && <p className="error-text">{ratingError}</p>}
                    </div> */}
                            <div className="description-section">
                                <label htmlFor="reopen-description" className='label'>Reason:</label>
                                <textarea
                                    id="reopen-description"
                                    value={reOpenDescription}
                                    onChange={(e) => { setReOpenDescription(e.target.value); if (descriptionError) setDescriptionError(""); }}
                                    placeholder="Please provide re-opening details"
                                    rows={4}
                                />
                                {descriptionError && <p className="error-text">{descriptionError}</p>}
                            </div>
                            <div>
                                {/* <span className='fw-bold'>Are you sure RE-OPEN the ticket status?</span> */}
                                <div className='d-flex justify-content-center'>
                                    <button type="submit" className="submit-button me-4">
                                        Send
                                    </button>
                                    {/* <button className="submit-button bg-secondary" onClick={() => {
                                        setIsReOpenModal(false); setReOpenId(); setSelectedRating(0);
                                        setReOpenDescription(""); setRatingError("");
                                        setDescriptionError("");
                                    }}>
                                        cancel
                                    </button> */}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    )

}

export default SellerSupportList;